export const DEBIT_ACC_CHECK = ['DEBIT COMPANY'];
export const DEBIT_RC_CHECK = ['DEBIT CHECK IN', 'DEBIT PAY'];

export const DEBIT_LINE_COLOR = ['DEBIT PAY', 'DEBIT COMPANY', 'DEBIT NOSHOW', 'DEBIT CHECK IN', 'DEBIT CANCEL'];
export const PAID_AT = 'PAID AT';
export const PAID_WITH = 'PAID WITH';
export const CANCEL_BILL = 'CANCEL BILL';